import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '@environments';
import { Rol } from '@shared/models/notificaciones/Rol';
import { Asignacion } from '@shared/models/usuarios/Asignacion';
import { BehaviorSubject, Observable } from 'rxjs';
import { UsuarioAeroplanta } from '@shared/models/abm/UsuarioAeroplanta';

@Injectable({
  providedIn: 'root'
})
export class AeroplantasService {
  
  recargarAsignaciones: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public recargarAsignaciones$ = this.recargarAsignaciones.asObservable();
  listaRoles = signal<Rol[]>([]);
  usuarioBaseUrl = environment.apiServer.usuariosBaseUrl;

  constructor(private http: HttpClient) { }

  getAsignaciones(): Observable<Asignacion[]> {
    return this.http.get<Asignacion[]>(`${this.usuarioBaseUrl}/UsuariosV1/Asignaciones`);
  }

  postAsignaciones(body: Asignacion): Observable<Asignacion> {
    return this.http.post<Asignacion>(`${this.usuarioBaseUrl}/UsuariosV1/Asignaciones`, body);
  }

  putAsignaciones(body: Asignacion): Observable<Asignacion> {
    return this.http.put<Asignacion>(`${this.usuarioBaseUrl}/UsuariosV1/Asignaciones`, body);
  }

  putAsignacionAeroplantas(asingar: boolean, body: UsuarioAeroplanta[]) {
    return this.http.put<Asignacion>(`${this.usuarioBaseUrl}/UsuariosV1/AsignacionAeroplantas?asignar=${asingar}`, body);
  }

  setRecargarAsignaciones(value: boolean) {
    this.recargarAsignaciones.next(value);
  }
}
